import React from 'react'
import propTypes from 'prop-types'
import Toggle from 'react-toggle'
import { Field, ErrorMessage } from 'formik'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'

import { useThrottle } from '@hooks/useThrottle'


export const ToggleFieldWithLabel = ({ label, name, style, withoutError, tooltip, readOnly, sublabel, onChange }) => {
  return (
    <div style={style} className={`form-field app-form__field`}>
      <Field name={name}
        render={({ field }) => {
          const { value, ...fieldPassThroughProps } = field
          const throttledOnChange = useThrottle(
            (e) => {
              field.onChange(e)
              onChange && onChange(e)
            }
          )

          return (
            <Box
              className='flex items-center gap-4'
            >
              <Tooltip title={tooltip || ''} placement='left-end'>
                <Box>
                  <Toggle
                    {...fieldPassThroughProps}
                    onChange={throttledOnChange}
                    value={String(value)}
                    checked={field.value}
                    icons={false}
                    disabled={readOnly}
                    className='app-toggle'
                  />
                </Box>
              </Tooltip>
              <Box display='flex' flexDirection='column'>
                <label>{label}</label>
                { sublabel &&
                  <small>{sublabel}</small>
                }
              </Box>
            </Box>)
          }
        }
      />
      {!withoutError &&
        <ErrorMessage component='span' name={name} />
      }
    </div>
  )
}

ToggleFieldWithLabel.propTypes = {
  name: propTypes.string.isRequired,
  label: propTypes.string.isRequired,
  sublabel: propTypes.string.isRequired,
  withoutError: propTypes.bool,
  tooltip: propTypes.string,
  style: propTypes.object,
  readOnly: propTypes.bool,
  onChange: propTypes.func
}


